export enum CommentaryTypeEnum {
  vatDeclaration = 'vat_declaration',
  companyPermanentNote = 'company_permanent_note'
}
